import TabHeader from "./TabHeader.jsx";
import Item from "./Item/Item.jsx";

export default Object.assign(TabHeader, {
  Item,
});
